import { render } from "./SalesDeliveryNotes.vue?vue&type=template&id=ff3b22ca&scoped=true"
import script from "./SalesDeliveryNotes.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryNotes.vue?vue&type=script&lang=js"

import "./SalesDeliveryNotes.vue?vue&type=style&index=0&id=ff3b22ca&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3b22ca"]])

export default __exports__